const COOKIE_NAME = 'yasno-gdpr';
const TIMER_COOKIE_NAME = 'yasno-gdpr-timer';
const COOKIE_EXPIRES = 'Tue, 19 Jan 2038 03:14:07 GMT';
const AUTO_ACCEPT_MINUTES = 5;

function getCookie(name) {
  const matches = document.cookie.match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`,
  ));

  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options = {}) {
  const params = { path: '/', ...options };

  if (params.expires instanceof Date) {
    params.expires = params.expires.toUTCString();
  }

  const parts = [`${encodeURIComponent(name)}=${encodeURIComponent(value)}`];

  Object.entries(params).forEach(([key, val]) => {
    parts.push(val === true ? key : `${key}=${val}`);
  });

  document.cookie = parts.join('; ');
}

const gdprTemplate = `
  <div id="y__gdpr__container">
    <div id="y__modal" style="visibility: hidden;" class="y__anim">
      <h3 id="y__gdpr__title">Мы используем куки 🍪</h3>
      <p id="y__gdpr__text">
        И <a
          target="_blank"
          href="/documents/Алгоритм_подбора_и_ранжирования_психологов.pdf"
          class="!_text-inherit !_underline hover:!_no-underline"
        >рекомендательные технологии</a>.
        <br>
        А здесь <a
          target="_blank"
          href="/personaldata"
          class="!_text-inherit !_underline hover:!_no-underline"
        >Политика конфиденциальности</a>
      </p>
      <div id="y__gdpr__btns">
        <button id="y__gdpr__accept__btn" type="button" class="_btn-medium _btn-base-primary">Ясно</button>
      </div>
    </div>
  </div>`;

function createWindow() {
  const div = document.createElement('div');

  div.className = 'y-gdpr';
  div.innerHTML = gdprTemplate;
  document.body.appendChild(div);

  return div;
}

function acceptCookies() {
  setCookie(COOKIE_NAME, 'accept', {
    expires: COOKIE_EXPIRES,
    secure: true,
  });
}

function initGdprBanner() {
  // Баннер уже отрисован другим бандлом на этой странице — выходим
  if (document.getElementById('y__gdpr__container')) {
    return;
  }

  // Показываем popup, если пользователь ещё не согласился с cookie
  if (!getCookie(COOKIE_NAME)) {
    const div = createWindow();
    const modal = div.querySelector('#y__modal');

    modal.classList.add('y__show');

    div.querySelector('#y__gdpr__accept__btn').addEventListener('click', () => {
      acceptCookies();
      modal.classList.remove('y__show');
    });

    // Запоминаем время первого показа popup
    if (!getCookie(TIMER_COOKIE_NAME)) {
      setCookie(TIMER_COOKIE_NAME, new Date().toISOString(), {
        expires: COOKIE_EXPIRES,
        secure: true,
      });
    }
  }

  // Автоматически принимаем cookie, если прошло больше 5 минут с первого показа
  if (getCookie(TIMER_COOKIE_NAME) && !getCookie(COOKIE_NAME)) {
    const modal = document.querySelector('#y__modal');
    const shownAt = new Date(getCookie(TIMER_COOKIE_NAME)).getTime();
    const minutesPassed = (Date.now() - shownAt) / 60000;

    if (minutesPassed >= AUTO_ACCEPT_MINUTES) {
      acceptCookies();

      if (modal) {
        modal.classList.remove('y__show');
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', initGdprBanner);
